<div class="row mt-4 no-gutters">
  <div class="col-12">
    <div class="row no-gutters bg-light">
      <div class="col-sm-8 col-7 p-2">
        <div>
          <span>{{servicePackageData.name}}</span>&nbsp;
          <sup class="badge badge-pill badge-success txt-small algin-middle badge-400">Account
            In-Use&nbsp;
            <span class="badge badge-light badge-400">{{servicePackageData.usageCount}}</span>
          </sup>
        </div>
        <div><small><span class="text-secondary"><i>{{servicePackageData.description}}</i></span></small>
        </div>
      </div>
      <div class="col-sm-4 col-5 text-right p-2">
        <small><i class="fas fa-times pointer ml-2 text-secondary" (click)="closeClicked()" data-toggle="tooltip"
            data-placement="right" title="Close"></i></small>
      </div>
    </div>

    <div class="row no-gutters">
      <div class="col-12 mt-3"><b>Package Services</b></div>
      <div class="col-12">
        <div class="table-responsive col-12 mt-3 pb-1 pl-0 pr-0">
          <table class="table" *ngFor="let serviceData of servicePackageData.services; let i = index">
            <thead class="thead-light table-striped">
              <tr>
                <td colspan="2" class="  table-header">{{serviceData.name}}</td>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="serviceData.serviceApis && serviceData.serviceApis.rest && serviceData.serviceApis.rest.apis">
                <tr *ngFor="let api of serviceData.serviceApis.rest.apis; let restapiindex = index">
                  <td width="30%" *ngIf="restapiindex==0" [attr.rowspan]="serviceData.serviceApis.rest.apis.length">
                    REST API
                  </td>
                  <td width="70%">
                    <span>
                      <span class="text-secondary">{{api.type}}</span>&nbsp;
                      <span>{{api.url}}</span><br>
                      <ng-container *ngIf="serviceData.serviceApis && serviceData.serviceApis.rest && serviceData.serviceApis.rest.authScheme">
                      <span class="text-secondary">Auth Type : </span>
                      <span>{{serviceData.serviceApis.rest.authScheme.authType | customText}}</span>&nbsp;&nbsp;
                      <span class="text-secondary">Auth Fields : </span>
                      <span
                        *ngFor="let authField of serviceData.serviceApis.rest.authScheme.authFields; let ik = index">
                        {{authField | customText}}
                        <span *ngIf="ik < serviceData.serviceApis.rest.authScheme.authFields.length - 1">
                          ,&nbsp;
                        </span>
                      </span>
                      </ng-container>
                    </span>
                  </td>
                </tr>
              </ng-container>
              <ng-container *ngIf="serviceData.serviceApis && serviceData.serviceApis.notifications">
                <ng-container *ngFor="let notification of serviceData.serviceApis.notifications; let j = index">
                  <tr *ngFor="let api of notification.apis; let j = index">
                    <td width="30%" *ngIf="j==0" [attr.rowspan]="notification.apis.length">
                      Notification
                    </td>
                    <td width="70%">
                      <span>
                        <span class="text-secondary">{{api.type}}</span>&nbsp;
                        <span>{{api.url}}</span><br>
                        <ng-container *ngIf="serviceData.serviceApis && serviceData.serviceApis.notifications && serviceData.serviceApis.notifications.authScheme">
                        <span class="text-secondary">Auth Type : </span>
                        <span>{{notification.authScheme.authType | customText}}</span>&nbsp;&nbsp;
                        <span class="text-secondary">Auth Fields : </span>
                        <span *ngFor="let authField of notification.authScheme.authFields; let ik = index">
                          {{authField | customText}}
                          <span *ngIf="ik < notification.authScheme.authFields.length - 1">
                            ,&nbsp;
                          </span>
                        </span>
                      </ng-container>
                      </span>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="serviceData.serviceApis && serviceData.serviceApis.pubSub">
                <tr *ngFor="let api of serviceData.serviceApis.pubSub.apis; let pubSubindex = index">
                  <td width="30%" *ngIf="pubSubindex==0" [attr.rowspan]="serviceData.serviceApis.pubSub.apis.length">
                    Pub-Sub
                  </td>
                  <td width="70%">
                    <span>
                      <span class="text-secondary">{{api.type}}</span>&nbsp;
                      <span>{{api.url}}</span><br>
                      <ng-container *ngIf="serviceData.serviceApis && serviceData.serviceApis.pubSub && serviceData.serviceApis.pubSub.authScheme">
                      <span class="text-secondary">Auth Type : </span>
                      <span>{{serviceData.serviceApis.pubSub.authScheme.authType | customText}}</span>&nbsp;&nbsp;
                      <span class="text-secondary">Auth Fields : </span>
                      <span
                        *ngFor="let authField of serviceData.serviceApis.pubSub.authScheme.authFields; let ik = index">
                        {{authField | customText}}
                        <span *ngIf="ik < serviceData.serviceApis.pubSub.authScheme.authFields.length - 1">
                          ,&nbsp;
                        </span>
                      </span>
                    </ng-container>
                    </span>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div *ngIf="selectedCountryRatePlan != null">
      <div class="mt-3 heading">Package Rate-Plan & Rates</div>
      
      <div class="row no-gutters" *ngIf="selectedCountryRatePlan.ratePlanType != 'PREPAID'">
        <div *ngIf="selectedCountryRatePlan.packageType && selectedCountryRatePlan.packageType == 'TRIAL'"
          class="col-12">
          <div class="table-responsive col-12 mt-3 pb-1 px-0">
            <table class="table">
              <thead class="thead-light">
                <tr>
                  <td colspan="2" scope="col">
                    <span>
                      Trial
                    </span>
                  </td>
                </tr>
                <tr>
                  <th scope="col">Duration</th>
                  <th scope="col">Post Trial</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="align-middle">
                    <span>{{utilService.convertMonthsToYearsAndMonths(selectedCountryRatePlan.trialPackage.trialPeriod.value)}}</span>
                  </td>
                  <td>
                    <span>{{selectedCountryRatePlan.trialPackage.postTrial | customText}}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div *ngIf="showPackageRatePlan()" class="col-12">
          <div class="table-responsive col-12 mt-3 pb-1 px-0">
            <table class="table">
              <thead class="thead-light">
                <tr>
                  <td [attr.colspan]="revenueShare ? '5' : '4'" scope="col" style="padding: 0px !important">
                    <div class="table-responsive col-12 px-0">
                      <table class="table plantype">
                        <thead class="thead-light">
                        </thead>
                        <tbody>
                          <tr>
                            <td width="30%" style="padding-right: 45px;">
                              <div><b>Rate-Plan Type</b></div>
                              <div class="mt-1">{{selectedCountryRatePlan.ratePlanType | customText}}</div>
                            </td>
                            <td width="25%">
                              <div><b>Usage Type</b></div>
                              <div class="mt-1">
                                <span *ngIf="selectedCountryRatePlan.usageType">{{selectedCountryRatePlan.usageType |
                                  customText}}</span>
                                <span *ngIf="selectedCountryRatePlan.usageType == null">-</span>
                              </div>
                            </td>
														<td width="45%">
															<div><b>Billing Proration</b></div>
															<div class="mt-1">
																<span *ngIf="servicePackageData && servicePackageData.billingProration else noBillingProration">{{billingProrations.get(servicePackageData.billingProration)}}</span>
																<ng-template #noBillingProration>
																	<span>-</span>
																</ng-template>
															</div>
														</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
                <tr *ngIf="!revenueShare">
                  <th scope="col" width="30%">Product Type</th>
                  <th scope="col" width="25%">Usage Tier</th>
                  <th scope="col" width="20%">
                    <select *ngIf="countries != null" id="countryMap" class="date-dropown" [(ngModel)]="selectedCountry"
                      (change)="onCountrySelected($event.target.value)" name="selectionCountry"
                      #selectionCountry="ngModel">
                      <option *ngFor="let country of countries; let i = index;" [ngValue]="country">
                        {{country}}
                      </option>
                    </select>
                    <span *ngIf="countries == null">Country</span>
                  </th>
                  <th scope="col" width="25%" class=" ">Rate</th>
                </tr>
                <tr *ngIf="revenueShare">
                  <th scope="col" width="30%">Product Type</th>
                  <th scope="col" width="25%">Usage Tier</th>
                  <th scope="col" width="20%">
                    <select *ngIf="countries != null" id="countryMap" class="date-dropown" [(ngModel)]="selectedCountry"
                      (change)="onCountrySelected($event.target.value)" name="selectionCountry"
                      #selectionCountry="ngModel">
                      <option *ngFor="let country of countries; let i = index;" [ngValue]="country">
                        {{country}}
                      </option>
                    </select>
                    <span *ngIf="countries == null">Country</span>
                  </th>
                  <th scope="col" width="12%" class=" ">Rate</th>
                  <th scope="col" width="13%">Revenue Share</th>
                </tr>
              </thead>
              <tbody>

                <tr *ngIf="selectedCountryRatePlan.ratePlanType != 'DEFAULT_SERVICE_RATES'">
                  <td>
                    {{getProductType(selectedCountryRatePlan.ratePlanType)}}
                  </td>
                  <td>
                    {{getUsageTier(selectedCountryRatePlan.licenseType)}}
                  </td>
                  <td>
                    <span *ngIf="selectedCountryRatePlan.country != null">{{selectedCountryRatePlan.country}}</span>
                    <span *ngIf="selectedCountryRatePlan.country == null">-</span>
                  </td>
                  <td>
                    <span *ngIf="selectedCountryRatePlan.fee != null">
                      <span>{{utilService.countryData.currencySign}} {{selectedCountryRatePlan.fee.value | number: '1.2-2'}}</span>
                      <span *ngIf="isVariableRate()">Variable</span>
                    </span>
                    <span *ngIf="selectedCountryRatePlan.fee == null">-</span>
                  </td>
                </tr>

                <ng-container *ngIf="selectedCountryRatePlan.ratePlanType != 'DEFAULT_SERVICE_RATES'">
                  <ng-container *ngFor="let tier of selectedCountryRatePlan.rateTypes; let i = index">
                    <ng-container *ngIf="tier && tier.rates">
  
                      <tr *ngIf="tier.scheme == 'Overage'">
                        <td>
                          <span *ngIf="tier.scheme == 'Overage'"><b>Overage</b></span>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td *ngIf="revenueShare"></td>
                      </tr>
  
                      <ng-container *ngFor="let rate of tier.rates; let j = index">
                        <tr *ngIf="tier.scheme != 'Unlimited' && rate.serviceFeeType != 'DEFAULT_DATA_TRNS'">
                          <td>
                            {{getProductType(rate.serviceFeeType)}}
                          </td>
                          <td>
                            <span *ngIf="tier.scheme == 'Base'"><span *ngIf="rate.tier != null"><span *ngIf="rate.tier.maximum != 'Unlimited'">Upto</span> {{rate.tier.maximum}}</span></span>
                            <span *ngIf="tier.scheme == 'Overage'"> > {{getBaseTierMaximum(selectedCountryRatePlan,
                              rate.serviceFeeType)}}</span>
                            <span *ngIf="tier.scheme == 'Default'">-</span>
                          </td>
                          <td>
                            <span *ngIf="selectedCountryRatePlan.country != null">{{selectedCountryRatePlan.country |
                              customText}}</span>
                            <span *ngIf="selectedCountryRatePlan.country == null">-</span>
                          </td>
                          <td>
                            <span
                              *ngIf="selectedCountryRatePlan.usageType && selectedCountryRatePlan.usageType == 'OVERAGE_CHARGING' && tier.scheme == 'Base'; else rateFee">
                              -
                            </span>
                            <ng-template #rateFee>
                              <span *ngIf="rate.fee && rate.fee.value">
                                <span>{{utilService.countryData.currencySign}} {{rate.fee.value | number: '1.2-2'}}</span>
                                <span *ngIf="isVariableRate()">Variable</span>
                              </span>
                              <span *ngIf="rate.fee == null || rate.fee.value == null">-</span>
                            </ng-template>
                          </td>
  
                          <td *ngIf="revenueShare">
                            <span *ngIf="revenueShare.revenueShareType == 'PERCENTAGE'; else absoluteRevenue">
                              {{revenueShare.value}}%
                            </span>
                            <ng-template #absoluteRevenue>
                              {{utilService.countryData.currency}} {{revenueShare.value | number : '1.2-2'}}
                            </ng-template>
                          </td>
                        </tr>
                      </ng-container>
  
                    </ng-container>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="selectedCountryRatePlan.ratePlanType == 'DEFAULT_SERVICE_RATES'">
                  <ng-container *ngFor="let tier of selectedCountryRatePlan.rateTypes; let i = index">
                    <ng-container *ngIf="tier && tier.rates">
  
                      <tr *ngIf="tier.scheme == 'Overage'">
                        <td>
                          <span *ngIf="tier.scheme == 'Overage'"><b>Overage</b></span>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td *ngIf="revenueShare"></td>
                      </tr>
  
                      <ng-container *ngFor="let rate of tier.rates; let j = index">
                        <tr *ngIf="tier.scheme != 'Unlimited' && rate.serviceFeeType != 'DEFAULT_DATA_TRNS'">
                          <td>
                            <!-- {{getProductType(rate.serviceFeeType)}} -->
														<div *ngFor="let service of rate.services; let k = index">
															<span *ngIf="service">{{service}}</span>
															<span *ngIf="k < rate.services.length - 1">,</span>
														</div>                            
                          </td>
                          <td>
                            <span *ngIf="tier.scheme == 'Base'"><span *ngIf="rate.tier != null"><span *ngIf="rate.tier.maximum != 'Unlimited'">Upto</span> {{rate.tier.maximum}}</span></span>
                            <span *ngIf="tier.scheme == 'Overage'"> > {{getBaseTierMaximum(selectedCountryRatePlan,
                              rate.serviceFeeType)}}</span>
                            <span *ngIf="tier.scheme == 'Default'">-</span>
                          </td>
                          <td>
                            <span *ngIf="selectedCountryRatePlan.country != null">{{selectedCountryRatePlan.country |
                              customText}}</span>
                            <span *ngIf="selectedCountryRatePlan.country == null">-</span>
                          </td>
                          <td>
                            <span
                              *ngIf="selectedCountryRatePlan.usageType && selectedCountryRatePlan.usageType == 'OVERAGE_CHARGING' && tier.scheme == 'Base'; else rateFee">
                              -
                            </span>
                            <ng-template #rateFee>
                              <span *ngIf="rate.fee && rate.fee.value">
                                <span>{{utilService.countryData.currencySign}} {{rate.fee.value | number: '1.2-2'}}</span>&nbsp;per
                                <!-- <span *ngIf="isVariableRate()">Variable</span> -->
																<span *ngIf="rate.chargeableUnit">{{rate.chargeableUnit | customText}}</span>&nbsp;<span *ngIf="rate.chargeableUnit == 'Data'">unit</span>
                              </span>
                              <span *ngIf="rate.fee == null || rate.fee.value == null">-</span>
                            </ng-template>
                          </td>
  
                          <td *ngIf="revenueShare">
                            <span *ngIf="revenueShare.revenueShareType == 'PERCENTAGE'; else absoluteRevenue">
                              {{revenueShare.value}}%
                            </span>
                            <ng-template #absoluteRevenue>
                              {{utilService.countryData.currency}} {{revenueShare.value | number : '1.2-2'}}
                            </ng-template>
                          </td>
                        </tr>
                      </ng-container>
  
                    </ng-container>
                  </ng-container>
                </ng-container>

              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="row no-gutters" *ngIf="selectedCountryRatePlan.ratePlanType == 'PREPAID'">
        <div class="col-12">
          <div class="table-responsive col-12 mt-3 pb-1 pl-0 pr-0">
            <table class="table">
              <thead class="thead-light">
                <tr>
                  <td colspan="2" scope="col">
                    <span>
                      Prepaid
                    </span>
                  </td>
                </tr>
                <tr>
                  <th scope="col">Term</th>
                  <th *ngIf="selectedCountryRatePlan.fixedTerm" scope="col">Duration</th>
                  <th *ngIf="selectedCountryRatePlan.variableTerm" scope="col">Cancellation Policy</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="selectedCountryRatePlan.fixedTerm">
                  <td class="align-middle">
                    Fixed
                  </td>
                  <td>
                    <span>{{utilService.convertMonthsToYearsAndMonths(selectedCountryRatePlan.fixedTerm.duration.value)}}</span>
                  </td>
                </tr>
                <tr *ngIf="selectedCountryRatePlan.variableTerm">
                  <td class="align-middle">
                    Variable
                  </td>
                  <td>
                    <div *ngFor="let term of selectedCountryRatePlan.variableTerm.terms">
                      <span>{{term | customText}}</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

    </div>


    <!-- <div *ngIf="servicePackageData.packageRatePlan.ratePlanType != 'PREPAID'" class="row no-gutters">
      <div class="col-12 mt-3"><b>Applied Rate-Plan</b></div>
      <div *ngIf="servicePackageData.packageRatePlan.packageType && servicePackageData.packageRatePlan.packageType == 'TRIAL'" class="col-12">
        <div class="table-responsive col-12 mt-3 pb-1 pl-0 pr-0">
          <table class="table">
            <thead class="thead-light">
              <tr>
                <td colspan="2" scope="col">
                  <span>
                    Trial
                  </span>
                </td>
              </tr>
              <tr>
                <th scope="col">Duration</th>
                <th scope="col">Post Trial</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="align-middle">
                  <span>{{utilService.convertMonthsToYearsAndMonths(servicePackageData.packageRatePlan.trialPackage.trialPeriod.value)}}</span>
                </td>
                <td>
                  <span>{{servicePackageData.packageRatePlan.trialPackage.postTrial | customText}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-12">
        <div class="table-responsive col-12 mt-3 pb-1 pl-0 pr-0">
          <table class="table">
            <thead class="thead-light">
              <tr>
                <td [attr.colspan]="revenueShare ? '6' : '5'" scope="col">
                  <span
                    *ngIf="servicePackageData.consolidatedRatePlan.ratePlanType=='LICENSE_BASED'; else showPlanType">
                    {{servicePackageData.consolidatedRatePlan.licenseType | customText}} Based License
                  </span>
                  <ng-template #showPlanType>
                    {{servicePackageData.consolidatedRatePlan.ratePlanType|customText}}
                  </ng-template>
                </td>
              </tr>
              <tr *ngIf="!revenueShare">
                <th scope="col" width="20%" class="">Plan</th>
                <th scope="col" width="26%">Services</th>
                <th scope="col" width="17%" class=" ">Units</th>
                <th scope="col" width="20%">Chargeable Units</th>
                <th scope="col" width="17%" class=" ">Rate ({{utilService.countryData.currency}})</th>
              </tr>
              <tr *ngIf="revenueShare">
                <th scope="col" width="20%" class="">Plan</th>
                <th scope="col" width="26%">Services</th>
                <th scope="col" width="12%" class=" ">Units</th>
                <th scope="col" width="15%">Chargeable Units</th>
                <th scope="col" width="12%" class=" ">Rate ({{utilService.countryData.currency}})</th>
                <th scope="col" width="15%" class="">Revenue Share</th>
              </tr>
            </thead>

            <tbody>
              <ng-container
                *ngFor="let tier of servicePackageData.consolidatedRatePlan.rateTypes; let i = index">
                <tr *ngFor="let rate of tier.rates; let j = index">
                  <td class="align-middle" *ngIf="j==0" [attr.rowspan]="tier.rates.length">
                    {{tier.scheme}}
                  </td>
                  <td class="text-muted">
                    <div *ngIf="rate.services && rate.services.length > 0">
                      <span *ngFor="let service of rate.services">{{service}}<br></span>
                    </div>
                    <div *ngIf="rate.services==undefined">
                      <span>{{rate.serviceFeeType|customText}}</span>
                    </div>
                  </td>
                  <td class="text-muted">
                    <span *ngIf="rate.tier">{{rate.tier.maximum}}</span>
                    <span *ngIf="!rate.tier">NA</span>
                  </td>
                  <td>
                    <span *ngIf="rate.serviceFeeType">{{rate.serviceFeeType}}</span>
                  </td>
                  <ng-container *ngIf="servicePackageData.consolidatedRatePlan.usageType && 
                    servicePackageData.consolidatedRatePlan.usageType=='OVERAGE_CHARGING'
                    && tier.scheme=='Base'; else rateFee">
                    <td *ngIf="j==0" class="text-muted" [attr.rowspan]="tier.rates.length">
                      <span>{{tier.fee.value | number: '1.2-2'}}</span>
                      <span *ngIf="isVariableRate()">Variable</span>
                    </td>
                  </ng-container>
                  <ng-template #rateFee>
                    <td class="text-muted">
                      <span *ngIf="rate.fee && rate.fee.value | isNotNullOrUndefined">{{rate.fee.value | number: '1.2-2'}}</span>
                      <span *ngIf="isVariableRate()">Variable</span>
                    </td>
                  </ng-template>
                  <td *ngIf="revenueShare">
                    <span *ngIf="revenueShare.revenueShareType == 'PERCENTAGE'; else absoluteRevenue">
                      {{revenueShare.value}}%
                    </span>
                    <ng-template #absoluteRevenue>
                      {{utilService.countryData.currency}} {{revenueShare.value | number : '1.2-2'}}
                    </ng-template>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div *ngIf="servicePackageData.packageRatePlan.ratePlanType == 'PREPAID'" class="row no-gutters">
      <div class="col-12 mt-3 heading">Package Rate-Plan</div>
      <div class="col-12">
        <div class="table-responsive col-12 mt-3 pb-1 pl-0 pr-0">
          <table class="table">
            <thead class="thead-light">
              <tr>
                <td colspan="2" scope="col">
                  <span>
                    Prepaid
                  </span>
                </td>
              </tr>
              <tr>
                <th scope="col" class="">Term</th>
                <th *ngIf="servicePackageData.packageRatePlan.fixedTerm" scope="col">Duration</th>
                <th *ngIf="servicePackageData.packageRatePlan.variableTerm" scope="col">Cancellation Policy</th>
                <th *ngIf="servicePackageData.consolidatedRatePlan.prepaidAmount && servicePackageData.consolidatedRatePlan.prepaidAmount.value" scope="col">Amount({{utilService.countryData.currency}})</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="servicePackageData.packageRatePlan.fixedTerm">
                <td class="align-middle">
                  Fixed
                </td>
                <td>
                  <span>{{utilService.convertMonthsToYearsAndMonths(servicePackageData.packageRatePlan.fixedTerm.duration.value)}}</span>
                </td>
                <td *ngIf="servicePackageData.consolidatedRatePlan.prepaidAmount && servicePackageData.consolidatedRatePlan.prepaidAmount.value">{{servicePackageData.consolidatedRatePlan.prepaidAmount.value}}</td>
              </tr>
              <tr *ngIf="servicePackageData.packageRatePlan.variableTerm">
                <td class="align-middle">
                  Variable
                </td>
                <td>
                  <div *ngFor="let term of servicePackageData.packageRatePlan.variableTerm.terms">
                    <span>{{term | customText}}</span>
                  </div>
                </td>
                <td *ngIf="servicePackageData.consolidatedRatePlan.prepaidAmount && servicePackageData.consolidatedRatePlan.prepaidAmount.value">{{servicePackageData.consolidatedRatePlan.prepaidAmount.value}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div> -->

    <div *ngIf="isNewRatePlanAvailable()" class="row no-gutters">
      <div class="col-12 pb-2 pt-1">
        <div class="row no-gutters pb-2">
          <div class="col-12 mt-2 pr-0 font-13">The new rate plan would be applied from {{getNewRatePlanAvailable() | date: utilService.countryData.dateFormat : utilService.countryData.timezone}}</div>
        </div>
      </div>
    </div>

    <div class="row no-gutters">
			<div class="col-12 pb-2 pt-1">
				<div class="row no-gutters pb-2 bg-light p-2">
					<div class="col-12 pr-0 heading">Package History</div>
				</div>

				<div class="col-12 font-13 pb-2 mt-2 pl-2" *ngIf="!servicePackageData || (!servicePackageData.publishedAt && !servicePackageData.updatedAt) else showPackageDates">
					None
				</div>
				<ng-template #showPackageDates>
					<div class="col-12 table-responsive p-0">
						<table class="table tbl-scrollable">
							<tbody class="max-height-57">
								<tr>
									<td style="width: 55%;">
										<span class="text-secondary">Published Date : </span>
										<span *ngIf="servicePackageData.publishedAt; else noPackageDate">{{servicePackageData.publishedAt | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormatHHMM : utilService.countryData.timezone}}</span>
									</td>
                  <td>
										<span class="text-secondary">Published By : </span>
										<span *ngIf="servicePackageData.publishedBy && servicePackageData.publishedBy.name; else noPackageDate">{{servicePackageData.publishedBy.name}}</span>
									</td>
								</tr>
								<tr>
									<td style="width: 55%;">
										<span class="text-secondary">Last Updated Date : </span>
										<span *ngIf="servicePackageData.updatedAt; else noPackageDate">{{servicePackageData.updatedAt | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormatHHMM : utilService.countryData.timezone}}</span>
									</td>
                  <td>
										<span class="text-secondary">Updated By : </span>
										<span *ngIf="servicePackageData.updatedBy && servicePackageData.updatedBy.name; else noPackageDate">{{servicePackageData.updatedBy.name}}</span>
									</td>
								</tr>
							</tbody>
						</table>
	
						<ng-template #noPackageDate><span>-</span></ng-template>
					</div>
				</ng-template>
			</div>
		</div>

    <div class="row no-gutters">
      <div class="col-12 pb-2 pt-1">
        <div class="row no-gutters pb-2 bg-light p-2 mb-2">
          <div class="col-12 pr-0 heading">Discounts</div>
        </div>

        <div *ngIf="isZeroFee(servicePackageData.consolidatedRatePlan) || servicePackageData.packageRatePlan.ratePlanType=='PREPAID'; else showDiscount" class="col-12 font-13 pb-2">
          NA
        </div>
        <ng-template #showDiscount>
          <div *ngIf="(!servicePackageData.packageRatePlan.discounts || servicePackageData.packageRatePlan.discounts.length == 0) && (servicePackageData.packageRatePlan.ratePlanType!='PREPAID' && !servicePackageData.packageRatePlan.baseTierDiscount && !servicePackageData.packageRatePlan.overageTierDiscount && !servicePackageData.packageRatePlan.additionalDiscount); else showDiscounts" class="col-12 font-13 pb-2">
            None
          </div>
          <ng-template #showDiscounts>
            <div class="font-13 pb-2 pl-2">Trim Discount: 
                <span *ngIf="servicePackageData.packageRatePlan.discounts && servicePackageData.packageRatePlan.discounts.length > 0">Yes</span>
                <span *ngIf="!servicePackageData.packageRatePlan.discounts || servicePackageData.packageRatePlan.discounts.length == 0">None</span>
            </div>

            <div class="font-13 pb-2 pl-2">Additional Discount: 
              <span
                *ngIf="(servicePackageData.packageRatePlan.ratePlanType=='DEFAULT_SERVICE_RATES_OVERAGE_PRICING' || servicePackageData.packageRatePlan.usageType == 'OVERAGE_CHARGING') && servicePackageData.packageRatePlan.baseTierDiscount">
                Base Tier : {{servicePackageData.packageRatePlan.baseTierDiscount}}%</span>
              <span
                *ngIf="(servicePackageData.packageRatePlan.ratePlanType=='DEFAULT_SERVICE_RATES_OVERAGE_PRICING' || servicePackageData.packageRatePlan.usageType == 'OVERAGE_CHARGING')&& servicePackageData.packageRatePlan.overAgeTierDiscount">
                &nbsp;&nbsp;&nbsp;&nbsp;Overage Tier : {{servicePackageData.packageRatePlan.overAgeTierDiscount}}%</span>
              <span
                *ngIf="servicePackageData.packageRatePlan.additionalDiscount">{{servicePackageData.packageRatePlan.additionalDiscount}}%</span>
              <span
                *ngIf="servicePackageData.packageRatePlan.ratePlanType!='PREPAID' && !servicePackageData.packageRatePlan.baseTierDiscount && !servicePackageData.packageRatePlan.overageTierDiscount && !servicePackageData.packageRatePlan.additionalDiscount">
                None</span>
            </div>
          </ng-template>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<div class="row no-gutters">
  <div class="col-12 pb-2 pt-1">
    <div class="row no-gutters pb-2 bg-light p-2 mb-2">
      <div class="col-12 pr-0 heading">
        <span>Vehicle Profiles</span>
      </div>
    </div>
    <div class="col-12 font-13 pb-2" *ngIf="!applicableVehicleProfiles || applicableVehicleProfiles.length == 0">
      None
    </div>
    <div class="table-responsive"
      *ngIf="applicableVehicleProfiles && applicableVehicleProfiles.length > 0">
      <table class="table table-striped tbl-scrollable">
        <thead class="thead-light">
          <tr>
            <th scope="col" width="23%">Brand</th>
            <th scope="col" width="25%">Model</th>
            <th scope="col" width="25%">Trim</th>
            <th scope="col" width="20%">Year</th>
          </tr>
        </thead>
        <tbody class="max-height-75">
          <tr *ngFor="let profile of applicableVehicleProfiles; let i = index">
            <td width="23%">{{profile.brand}}</td>
            <td width="25%">{{profile.model}}</td>
            <td width="25%">{{profile.trimName}}</td>
            <td width="20%">{{profile.year}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>